export default __webpack_public_path__ + "static/media/kausi9-min.3eda2b4c.jpg";